import { render, staticRenderFns } from "./notify-research-team.vue?vue&type=template&id=6b2ac44e&scoped=true&"
import script from "./notify-research-team.vue?vue&type=script&lang=js&"
export * from "./notify-research-team.vue?vue&type=script&lang=js&"
import style0 from "./notify-research-team.vue?vue&type=style&index=0&id=6b2ac44e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ac44e",
  null
  
)

component.options.__file = "notify-research-team.vue"
export default component.exports